<template>
    <div id="filter-sidebar" class="p-0 body_content_left_col">
        <div class="gdc-filter-wrapper d-flex flex-column" data-inc="GDC - Filters">
            <div class="automation-search-wrapper order-1 order-md-0 search-wrapper">
                <autocomplete
                    :suggestions="this.filteredArticles"
                    v-model="searchTerm"
                    :placeholder="searchPlaceholderText"
                ></autocomplete>
            </div>
            <div class="order-0 order-md-1 gdc-filter__attributes-controls clearfix">
                <button
                    type="button"
                    class="btn filter-btn"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="isActive = true"
                >
                    <img class="lazyload slot-games-filter-icon" :src="filterIcon" width="22" height="22" />
                    <span>{{ filterLabelText.toUpperCase() }}</span>
                    <span class="d-inline d-md-none" v-show="activeFilters.length > 0">
                        ({{ activeFilters.length }})
                    </span>
                </button>
                <div class="label">
                    {{ filterLabelText.toUpperCase() }}
                </div>
                <div class="d-none d-md-block text-center">
                    <button
                        class="btn filter-clearall-btn gdc-filter-reset-btn"
                        @click="clearFilters()"
                        v-show="activeFilters.length > 0"
                    >
                        <span>{{ clearLabelText }}</span>
                    </button>
                </div>
            </div>
            <div class="d-none d-md-block order-2 order-md-2 selected-filters pt-3">
                <ul class="p-0">
                    <li
                        v-for="filterAttribute in activeFilters"
                        :key="filterAttribute.id"
                        @click="toggleFilter(filterAttribute)"
                    >
                        <div class="d-flex justify-content-between align-items-center">
                            <span>{{ filterAttribute.name }}</span>
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 16 16"
                                    style="margin: -1px 0 0 1px"
                                >
                                    <path
                                        fill="#fff"
                                        d="M 15.96875 14.019531 L 9.847656 7.957031 L 15.90625 1.839844 L 14.019531 -0.03125 L 7.960938 6.089844 L 1.84375 0.03125 L -0.03125 1.902344 L 6.09375 7.972656 L 0.03125 14.097656 L 1.902344 15.96875 L 7.976562 9.839844 L 14.097656 15.90625 Z M 15.96875 14.019531"
                                    />
                                </svg>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
            <hr />
            <div
                class="dropdown-menu gdc-filter clearfix order-4 order-md-4"
                :class="{ 'is-active': isActive }"
                id="filters-dropdown"
            >
                <div class="d-md-none d-flex justify-content-between bg-white mobile-header">
                    <div>
                        <img class="lazyload slot-games-filter-icon" :src="filterIcon" width="22" height="22"/>
                        {{ filterLabelText }}
                    </div>
                    <div class="close-div" @click="isActive = false">
                        {{ closeLabelText }}
                        <svg
                            class="ml-1 closeTooltip"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            aria-hidden="true"
                            role="img"
                            width="24"
                            height="24"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 50 50"
                        >
                            <path
                                d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z"
                                fill="#d23b42"
                            />
                            <path
                                d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z"
                                fill="#d23b42"
                            />
                        </svg>
                    </div>
                </div>
                <div class="gdc-filter__dropdown-panel__scrollable" style="height: auto">
                    <div
                        v-for="filter in filters"
                        :key="filter.id"
                        class="filter_box gdc-filter__attribute"
                        :class="filter.label | labelToClass"
                        role="group"
                    >
                        <div class="gdc-filter__dropdown-panel">
                            <h3
                                class="mx-3 m-md-0 pb-md-2"
                                data-toggle="collapse"
                                :data-target="'#label_' + filter.id"
                                aria-expanded="false"
                            >
                                {{ filter.label }}
                                <span class="icon d-inline d-md-none float-right">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 17 17"
                                    >
                                        <g transform="translate(17,17) rotate(180)">
                                            <path
                                                fill="#979797"
                                                d="M 0 5.191406 L 2.003906 3.1875 L 8.503906 9.800781 L 14.996094 3.1875 L 17 5.191406 L 8.503906 13.8125 Z M 0 5.191406"
                                            />
                                        </g>
                                    </svg>
                                </span>
                            </h3>
                            <ul
                                class="gdc-filter__attributes-list ml-0 p-0 mr-3 mr-md-0 collapse"
                                :id="'label_' + filter.id"
                                data-parent="#filters-dropdown"
                            >
                                <li
                                    class="mx-3 m-md-0 p-0"
                                    v-for="filterAttribute in filter.attributes"
                                    :key="filterAttribute.id"
                                    @click="toggleFilter(filterAttribute)"
                                >
                                    <span
                                        :data-attr-id="filterAttribute.id"
                                        class="
                                            d-flex
                                            mt-1
                                            align-items-center
                                            gdc-filter__attribute-btn
                                        "
                                        :class="{
                                            'gdc-filter__attribute-btn--disabled':
                                                filterAttribute.is_disabled,
                                        }"
                                    >
                                        <span
                                            class="
                                                gdc-filter__attribute-btn__checkbox
                                                mr-2
                                                overflow-hidden
                                            "
                                        >
                                            <span v-show="filterAttribute.is_active">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="12"
                                                    viewBox="0 0 16 16"
                                                    style="margin-top: -15px"
                                                >
                                                    <path
                                                        fill="#fff"
                                                        d="M 6 14.023438 L 0 8.265625 L 1.859375 6.351562 L 5.964844 10.265625 L 14.105469 1.976562 L 16 3.855469 Z M 6 14.023438"
                                                    />
                                                </svg>
                                            </span>
                                        </span>
                                        <span
                                            class="gdc-filter__attribute-btn__label"
                                            :class="{ bold: filterAttribute.is_active }"
                                        >
                                            {{ filterAttribute.name }}
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <hr />
                    </div>
                </div>
                <div
                    class="d-flex justify-content-center align-items-center d-block d-md-none pt-5"
                >
                    <div class="btn clear-btn" @click="clearFilters()">
                        {{ clearLabelText }}
                    </div>
                    <div class="btn save-btn" @click="isActive = false">
                        {{ saveLabelText.toUpperCase() }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        initialFilters: Array,
        articles: Array,
        filterIcon: String,
    },
    data() {
        return {
            filters: this.initialFilters,
            searchTerm: '',
            isActive: false,
        };
    },
    // Enabling this function would disable (keep the filter from showing up in the filter list) any filters that is not used by any articles
    // Not sure if this behavior is wanted
    // created: function () {
    //     this.filters = this.filters.map((filter) => {
    //         filter.attributes.forEach((attr) => {
    //             attr.is_active = false;
    //             attr.filter_id = filter.id;
    //             attr.is_disabled = this.filteredArticles.every((article) => {
    //                 if (!article[attr.attribute_type_id].includes(attr.attribute_value)) {
    //                     return true;
    //                 }
    //                 return false;
    //             });
    //         });
    //         filter.attributes = filter.attributes.filter((item) => item.is_disabled == false);
    //         return filter;
    //     });
    // },
    computed: {
        activeFilters() {
            return this.filters
                .map((filter) => filter.attributes.filter((attr) => attr.is_active))
                .flat();
        },
        filteredArticles() {
            return this.articles.filter((article) => {
                let active = [];

                active = this.activeFilters.map((filter) => {
                    // filter.attribute_type_id is either product_type_id or product_faeture_id
                    // check the article to see if the value of the id exist
                    if (article[filter.attribute_type_id].includes(filter.attribute_value)) {
                        return true;
                    }
                    return false;
                });

                // We could have multiple filters selected
                // An article that matches any 1 filter is true here
                let hasFilters = active.includes(true);

                let hasSearch =
                    this.searchTerm === ''
                        ? true
                        : article.title.toLowerCase().includes(this.searchTerm.toLowerCase());

                // If we have a filter selected, the article must match both the filter and searchTerm
                if (this.activeFilters.length > 0) {
                    return hasFilters && hasSearch;
                } else {
                    // If we don't have a filter selected, the article can match either or
                    return hasFilters || hasSearch;
                }
            });
        },
        clearLabelText() {
            return window.translations.slotGameFilters.clear_label || 'CLEAR ALL';
        },
        searchPlaceholderText() {
            return (
                window.translations.siteArticleStrategyFilter.search_placeholder ||
                'Search articles...'
            );
        },
        filterLabelText() {
            return window.translations.slotGameFilters.filter_label || 'Filter';
        },
        closeLabelText() {
            return window.translations.slotGameFilters.close_label || 'Close';
        },
        saveLabelText() {
            return window.translations.slotGameFilters.save_label || 'Save';
        },
    },
    watch: {
        initialFilters(val) {
            this.filters = val;
        },
        searchTerm(val) {
            // this.disableFilters();
            this.$emit('input', this.filteredArticles);
        },
    },
    methods: {
        // This function would disable filters that are not used by any articles
        // It is from the slot games filter, has been modified to work with articles
        // However, not sure if this behavior is needed so commented out the usage for now.
        disableFilters() {
            this.filters = this.filters.map((filter) => {
                filter.attributes.forEach((attr) => {
                    attr.is_disabled = this.filteredArticles.every((article) => {
                        if (!article[attr.attribute_type_id].includes(attr.attribute_value)) {
                            return true;
                        }
                        return false;
                    });
                });

                return filter;
            });
        },
        toggleFilter(filterAttribute) {
            if (filterAttribute.is_disabled) {
                return;
            }
            filterAttribute.is_active = !filterAttribute.is_active;
            // this.disableFilters();
            this.$emit('input', this.filteredArticles);
            // this.disableFilters();
        },
        clearFilters() {
            this.filters = this.filters.map((filter) => {
                filter.attributes.forEach((attr) => (attr.is_active = false));

                return filter;
            });
            // this.disableFilters();
            this.$emit('input', this.filteredArticles);
            // this.disableFilters();
        },
    },
    filters: {
        labelToClass(label) {
            if (!label) {
                return '';
            }

            return label.replace(' ', '_').toLowerCase();
        },
    },
};
</script>
